var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { attrs: { "label-width": "100px" } },
    [
      _c(
        "el-tabs",
        {
          on: {
            "tab-click": function ($event) {
              return _vm.handleFilter("tab")
            },
          },
          model: {
            value: _vm.queryParams.orderStatus,
            callback: function ($$v) {
              _vm.$set(_vm.queryParams, "orderStatus", $$v)
            },
            expression: "queryParams.orderStatus",
          },
        },
        _vm._l(_vm.statusText, function (item, index) {
          return _c("el-tab-pane", {
            key: index,
            attrs: { name: item.id, label: `${item.text}（${item.value}）` },
          })
        }),
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "时间选择" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "flex-row",
                      attrs: { type: "button" },
                      on: { change: _vm.dateRangeChange },
                      model: {
                        value: _vm.dateText,
                        callback: function ($$v) {
                          _vm.dateText = $$v
                        },
                        expression: "dateText",
                      },
                    },
                    [
                      _vm._l(_vm.dateSelect, function (item, index) {
                        return _c(
                          "el-radio-button",
                          { key: index, attrs: { label: item.value } },
                          [_vm._v(_vm._s(item.text))]
                        )
                      }),
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          editable: false,
                          "range-separator": "至",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.timeRangeChange },
                        model: {
                          value: _vm.timeRange,
                          callback: function ($$v) {
                            _vm.timeRange = $$v
                          },
                          expression: "timeRange",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { sm: 24, md: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收货人" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入收货人姓名、手机号",
                      clearable: "",
                    },
                    model: {
                      value: _vm.queryParams.consigneeInfo,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "consigneeInfo", $$v)
                      },
                      expression: "queryParams.consigneeInfo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入订单号", clearable: "" },
                    model: {
                      value: _vm.queryParams.orderNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "orderNumber", $$v)
                      },
                      expression: "queryParams.orderNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { sm: 24, md: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "用户昵称、手机号、分享码",
                      clearable: "",
                    },
                    model: {
                      value: _vm.queryParams.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "keyword", $$v)
                      },
                      expression: "queryParams.keyword",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "支付单号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入支付单号", clearable: "" },
                    model: {
                      value: _vm.queryParams.payNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "payNumber", $$v)
                      },
                      expression: "queryParams.payNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.showSupplier
            ? _c(
                "el-col",
                { attrs: { sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "last-form-item",
                      attrs: {
                        "label-width":
                          _vm.device !== "mobile" ? "auto" : "100px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: {
                            click: function ($event) {
                              return _vm.handleFilter("btn")
                            },
                          },
                        },
                        [_vm._v("查找")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.showSupplier
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              ["0", "4"].includes(_vm.queryParams.orderStatus)
                ? _c(
                    "el-col",
                    { attrs: { sm: 24, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: { "last-form-item": _vm.device !== "mobile" },
                          attrs: { label: "配送方式" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择配送方式",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryParams.deliveryMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryParams,
                                    "deliveryMethod",
                                    $$v
                                  )
                                },
                                expression: "queryParams.deliveryMethod",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "自提", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "快递", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.queryParams.orderType === 77000
                ? _c(
                    "el-col",
                    { attrs: { sm: 24, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: { "last-form-item": _vm.device !== "mobile" },
                          attrs: { label: "商家名称" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入商家名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryParams.shopName,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "shopName", $$v)
                              },
                              expression: "queryParams.shopName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-col",
                    { attrs: { sm: 24, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class: { "last-form-item": _vm.device !== "mobile" },
                          attrs: { label: "供应商" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: "请选择供应商",
                              },
                              on: { change: _vm.supplierChange },
                              model: {
                                value: _vm.queryParams.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "supplierId", $$v)
                                },
                                expression: "queryParams.supplierId",
                              },
                            },
                            _vm._l(_vm.suppliers, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.supplierName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _c(
                "el-col",
                { attrs: { sm: 24, md: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "last-form-item",
                      attrs: {
                        "label-width":
                          _vm.device !== "mobile" ? "auto" : "100px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: {
                            click: function ($event) {
                              return _vm.handleFilter("btn")
                            },
                          },
                        },
                        [_vm._v("查找")]
                      ),
                      _c(
                        "el-upload",
                        {
                          staticStyle: { margin: "0 10px" },
                          attrs: {
                            action: "#",
                            "show-file-list": false,
                            "before-upload": _vm.beforeExcelUpload,
                            "http-request": _vm.handleImport,
                            accept:
                              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                icon: "el-icon-download",
                              },
                            },
                            [_vm._v("导入")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "info", icon: "el-icon-upload2" },
                          on: { click: _vm.handleExport },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }